import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ENVIRONMENT } from '@ninety/mobile/platform/environments';

import { CompanyLanguage } from '../company/models/custom-language';

/** HTTP client for the monolith Language endpoints. */
@Injectable({ providedIn: 'root' })
export class LanguageApiService {
  private readonly http = inject(HttpClient);
  private readonly monolith = inject(ENVIRONMENT).origin.monolith;

  getCompanyLanguage(): Observable<CompanyLanguage> {
    return this.http.get<CompanyLanguage>(`${this.monolith}/Language/Company`);
  }
}
